/**
 * Helpers for keeping a list's search, filters and sorting in the page's query
 * string, so the list survives opening a row and pressing back, a refresh, or
 * being shared as a link.
 */

/**
 * Writes a value, or removes the key when the value is empty. A filter sitting
 * at its default says nothing, so it stays out of the URL.
 */
export function setOrDeleteParam(
    params: URLSearchParams,
    key: string,
    value: string
): void {
    if (value) {
        params.set(key, value);
    } else {
        params.delete(key);
    }
}

/**
 * Ascending unless the query string explicitly says otherwise — the value is
 * user-editable, so anything unrecognised falls back to the default.
 */
export function parseSortOrder(value: string | null): 'asc' | 'desc' {
    return value === 'desc' ? 'desc' : 'asc';
}
